import React, {
    useLayoutEffect, useEffect, useRef, useState,
} from "react";
import Image from "@root/components/image";
import Icon from "../Icon/icon";
import ResponsiveWrapper from "../_responsive-wrapper";

const ColorItem = ({ item, value, onChange, disableHover }) => {
    const hoverImageRef = useRef(null);
    const [translateX, setTranslateX] = useState(0);
    const [windowWidth, setWindowWidth] = useState(0);

    // on window resize, reposition the image
    useEffect(() => {
        if (typeof window === "undefined") return;

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useLayoutEffect(() => {
        if (hoverImageRef.current) {
            const imageRect = hoverImageRef.current.getBoundingClientRect();
            setTranslateX(Math.max(imageRect.right - window.innerWidth + 10 + translateX, 0) + 15);
        }
    }, [value, windowWidth]);

    const backgroundStyle = {
        "--color": item.color,
        ...(item.passiveColor && { "--gradient": `linear-gradient(-90deg, ${item.color} 50%, ${item.passiveColor} 50%)` }),
    };
    
    return (
        <div
            className={`color-swatch__option ${item.passiveColor ? "color-swatch__option--passive-color" : ""}`}
            style={backgroundStyle}
        >
            <input
                type="radio"
                id={`color-${item.name}`}
                className="color-swatch__input"
                checked={value === item.name}
                onChange={() => onChange(item.name)}
            />
            <label
                htmlFor={`color-${item.name}`}
                className="color-swatch__color"
                data-disable-hover={disableHover ? "true" : undefined}
                onTouchEnd={() => onChange(item.name)}
            >
                {value === item.name ? (
                    <Icon icon="check" className="color-swatch__icon" />
                ) : null}
                {item.image && (
                    <div
                        className="color-swatch__image"
                        ref={hoverImageRef}
                        style={{ "--translateX": `-${translateX}px` }}
                    >
                        <Image image={item.image} alt={item.name} />
                    </div>
                )}
            </label>
        </div>
    );
};

const ColorSwatch = ({ baseLabel = "Color:", colors, value, onChange, noLabel, disableHover }) => (
    <ResponsiveWrapper className="color-swatch">
        {noLabel !== true ? (
            <label className="color-swatch__label">
                <span>{baseLabel}</span>
                {value}
            </label>
        ) : null}
        <div className="color-swatch__options">
            {colors?.map((item) => (
                <ColorItem
                    key={item.name}
                    item={item}
                    value={value}
                    onChange={onChange}
                    disableHover={disableHover}
                />
            ))}
        </div>
    </ResponsiveWrapper>
);

export default ColorSwatch;
